interface WorkSpaceProps {
  workspaceKey: string;
  workspaceName: string;
  workspaceLogo: string | null;
  organizationKey: string;
  organizationName: string;
  organizationLogo: string | null;
}

export class WorkSpace {
  private readonly _workspaceKey: string;
  private readonly _workspaceName: string;
  private readonly _workspaceLogo: string | null;
  private readonly _organizationKey: string;
  private readonly _organizationName: string;
  private readonly _organizationLogo: string | null;

  constructor(props: WorkSpaceProps) {
    this._workspaceKey = props.workspaceKey;
    this._workspaceName = props.workspaceName;
    this._workspaceLogo = props.workspaceLogo;
    this._organizationKey = props.organizationKey;
    this._organizationName = props.organizationName;
    this._organizationLogo = props.organizationLogo;
  }

  get workspaceKey(): string {
    return this._workspaceKey;
  }

  get workspaceName(): string {
    return this._workspaceName;
  }

  get workspaceLogo(): string | null {
    return this._workspaceLogo;
  }

  get organizationKey(): string {
    return this._organizationKey;
  }

  get organizationName(): string {
    return this._organizationName;
  }

  get organizationLogo(): string | null {
    return this._organizationLogo;
  }
}
